import styled from 'styled-components';
export var AuthorBlock = styled.div.withConfig({
  displayName: "AuthorBlock",
  componentId: "sc-f3b8nw-0"
})(["display:flex;position:relative;align-items:center;width:100%;user-select:none;small{", ";font-weight:500;color:", ";a{color:", ";}}strong{a{display:inline-block;color:currentColor;&:first-letter{text-transform:uppercase;}&:hover{color:", ";}}}"], function (_ref) {
  var badge = _ref.badge;
  return !badge && 'padding-top: 3px';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.fontL;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.linkColor;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.mainColor;
});
export var CompanyLink = styled.a.withConfig({
  displayName: "AuthorBlock__CompanyLink",
  componentId: "sc-f3b8nw-1"
})([""]);